import http from "../http-common";

class ServiceHistoryDataService {
  // Get all service histories
  getAll() {
    return http.get('/service-histories');
  }

  // Get service history by ID
  get(id) {
    return http.get(`/service-histories/${id}`);
  }

  // Create new service history
  create(data) {
    return http.post('/service-histories', data);
  }

  // Update service history
  update(id, data) {
    return http.put(`/service-histories/${id}`, data);
  }

  // Delete service history
  delete(id) {
    return http.delete(`/service-histories/${id}`);
  }

  // Get service histories by client
  getByClient(clientId) {
    return http.get(`/clients/${clientId}/service-histories`);
  }

  // Get service histories by service
  getByService(serviceId) {
    return http.get(`/services/${serviceId}/service-histories`);
  }
}

export default new ServiceHistoryDataService();
